<div class="container modal-cadastro-login" *ngIf="step === 'login'">
  <div class="row">
    <div class="col-lg-12 mr-auto ml-auto">
      <h3 class="text-center mb-3">
        <i class="fa fa-lock"></i> Entrar como <b>Candidato</b>
      </h3>
      <app-formulario-login
        [tipoConta]="'candidato'"
        [parametros]="parametros"
        [exibirLinkCadastro]="false"
      ></app-formulario-login>
      <p class="cadastrar">
        Não possui uma conta?
        <a
          href="javascript:void(0)"
          routerLink=""
          (click)="abrirFormularioCadastro()"
          ><b>Cadastre se aqui.</b></a
        >
      </p>
    </div>
  </div>
</div>

<div class="container modal-cadastro-login" *ngIf="step === 'cadastro'">
  <div class="row">
    <div class="col-lg-12 mr-auto ml-auto">
      <h3 class="text-center mb-3">
        <i class="fa fa-lock"></i> Cadastrar como <b>Candidato</b>
      </h3>
      <div class="form-group">
        <a href="javascript:;" (click)="loginFacebook()"
          ><button type="button" class="btn btn-primary btn-lg btn-block">
            <i class="fa fa-facebook"></i> Continuar com Facebook
          </button></a
        >
      </div>

      <div class="form-group">
        <a
          (click)="salvarParametros()"
          href="http://reachr-login-linkedin.herokuapp.com?client_id=77hxwubktxlv3r&client_secret=iuA4Z8fwlaJR9Yue"
          ><button type="button" class="btn btn-info btn-lg btn-block">
            <i class="fa fa-linkedin"></i> Continuar com Linkedln
          </button></a
        >
      </div>

      <div class="form-group">
        <hr data-content="OU" class="hr-text" />
      </div>

      <form
        class="form"
        novalidate
        [formGroup]="formdata"
        (ngSubmit)="criarConta(formdata)"
      >
        <div class="alert alert-danger" *ngIf="showUsuarioCadastrado" autofocus>
          Usuário já cadastrado.
        </div>
        <div class="alert alert-danger" *ngIf="isError">
          {{ errorMessage }}
        </div>

        <div class="form-group">
          <label>Nome completo</label>
          <input
            type="text"
            class="form-control"
            required
            name="Nome"
            formControlName="Nome"
            placeholder="Nome completo"
          />
          <div
            class="message-error"
            *ngIf="Nome.errors && (Nome.dirty || Nome.touched)"
          >
            <p *ngIf="Nome.errors.required">Insira o nome</p>
            <p *ngIf="Nome.errors.minlength">Insira o nome completo</p>
          </div>
        </div>

        <div class="form-group">
          <label>Email</label>
          <input
            type="email"
            class="form-control"
            required
            name="Email"
            formControlName="Email"
            placeholder="Email"
          />
          <div
            class="message-error"
            *ngIf="Email.errors && (Email.dirty || Email.touched)"
          >
            <p *ngIf="Email.errors.required">Insira o email</p>
            <p *ngIf="Email.errors.pattern">Verifique seu email</p>
          </div>
        </div>

        <div class="form-group">
          <label>Senha</label>
          <input
            type="password"
            class="form-control"
            required
            formControlName="Password"
            name="Password"
            placeholder="Senha"
          />
          <div
            class="message-error"
            *ngIf="Password.errors && (Password.dirty || Password.touched)"
          >
            <p *ngIf="Password.errors.required">Insira sua senha</p>
            <p *ngIf="Password.errors.minlength">Mínimo 6 caracteres</p>
          </div>
        </div>

        <div class="form-group">
          <label>Telefone</label>
          <input
            type="text"
            class="form-control"
            required
            name="Telefone"
            formControlName="Telefone"
            placeholder="Telefone"
          />
          <div
            class="message-error"
            *ngIf="Telefone.errors && (Telefone.dirty || Telefone.touched)"
          >
            <p *ngIf="Telefone.errors.required">Insira o telefone</p>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            empresaId !== '0c81f7e6-84ee-4c30-845a-f425382e83c0' &&
            empresaId !== '0bddcefe-ffa6-47bb-8853-98211d9e6f69'
          "
        >
          <label>Currículo</label>
          <div *ngIf="empresaId === '62648712-1e97-4d76-bfbc-0bf175cb44e6'">
            <input
              type="file"
              id="curriculo"
              class="col-md-12"
              accept=".pdf"
              (change)="onFileChange($event)"
            />
            <small class="ml-3"
              ><em
                >*Envio obrigatório do currículo somente no formato PDF</em
              ></small
            >
          </div>
          <div *ngIf="empresaId !== '62648712-1e97-4d76-bfbc-0bf175cb44e6'">
            <input
              type="file"
              id="curriculo"
              class="col-md-12"
              accept=".pdf, .doc, .docx"
              (change)="onFileChange($event)"
            />
          </div>
        </div>

        <div class="form-group">
          <p>
            <input required formControlName="TermosDeUso" type="checkbox" />Li e
            aceito os
            <a target="_blank" href="{{ siteUrl }}/termos-de-uso"
              >termos de uso</a
            >.
          </p>
          <div
            class="message-error"
            *ngIf="
              TermosDeUso.errors && (TermosDeUso.dirty || TermosDeUso.touched)
            "
          >
            <p *ngIf="TermosDeUso.errors.required">Aceito os termos de uso</p>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="formdata.invalid || criandoConta"
          class="btn btn-success btn-block"
        >
          Criar conta
        </button>
      </form>

      <p class="cadastrar">
        Já tenho conta!
        <a
          href="javascript:void(0)"
          [routerLink]="[]"
          (click)="abrirFormularioLogin()"
          ><b>Retornar para o Login.</b></a
        >
      </p>
    </div>
  </div>
</div>
